<div
  id="SearchHektometerComponent"
  class="card esri-widget animation-on-tool-open"
  #searchHektometerComponentRef
  gisDraggableWidget
  [dragHandle]="dragArea"
>
  <!--- the card header -->
  <div class="card-header" #dragArea>
    <div class="row">
      <div class="col-md-9" translate>
        HEADER_PANEL.SEARCH_HEKTOMETER
      </div>
      <div class="col-md-3">
        <i class="material-icons md-18 float-right" (click)="destroySelf()">close</i>
        <i class="material-icons md-18 float-right pr-1" (click)="collapseWidget()">exit_to_app</i>
      </div>
    </div>
  </div>

  <!-- the card body -->
  <div class="card-body">
    <form [formGroup]="formGroup">
      <div class="form-row">
        <!--- Kilometrierungslinie -->
        <div class="form-group col-12">
          <label for="taNummerierung" translate
            >WIDGET.SEARCH_HEKTOMETER.KILOMETRIERUNGSLINIE</label
          >
          <input
            #nummerierungRef
            autocomplete="off"
            id="taNummerierung"
            name="taNummerierung"
            [(ngModel)]="this.searchTextNummerierung"
            [ngModelOptions]="{standalone: true}"
            [typeahead]="this.searchListNummerierung"
            [typeaheadOptionField]="'name'"
            [typeaheadWaitMs]="100"
            [typeaheadMinLength]="1"
            (typeaheadLoading)="typeaheadService.onSearchLoading($event)"
            (typeaheadNoResults)="typeaheadService.onSearchNoResults($event)"
            (typeaheadOnSelect)="typeaheadService.onSearchSelect($event)"
            (change)="clearKMField()"
            placeholder="Kilometrierungslinie..."
            class="form-control form-control-sm"
          />
        </div>

        <!--- Hektometer -->
        <div class="form-group col-12">
          <label for="taKm" translate>WIDGET.SEARCH_HEKTOMETER.KM</label>
          <input
            #kmRef
            autocomplete="off"
            id="taKm"
            name="taKm"
            [(ngModel)]="this.searchTextKm"
            [ngModelOptions]="{standalone: true}"
            [typeahead]="this.searchListKm"
            [typeaheadOptionField]="'name'"
            [typeaheadWaitMs]="100"
            [typeaheadMinLength]="1"
            [maxLength]="12"
            (typeaheadLoading)="typeaheadService.onSearchLoading($event)"
            (typeaheadNoResults)="typeaheadService.onSearchNoResults($event)"
            (typeaheadOnSelect)="typeaheadService.onSearchSelect($event)"
            placeholder="KM...."
            class="form-control form-control-sm"
          />
        </div>

        <!--- buttons -->
        <div class="form-group col-12">
          <button class="btn btn-primary btn-block" (click)="searchHektometer()" translate>
            <span class="esri-icon-locate"></span>
            COMMON.SEARCH_BUTTON_TEXT
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
